
<template>
  <div class="main_empty"
       v-if="propJson.showToast">
    <div class="shadow"
         @click="toHide"></div>
    <div class="toast">
      <h1 class="title">{{propJson.title}}</h1>
      <p class="message"
         v-if="propJson.message">
        <span v-if="propJson.tag"
              class="tag">{{propJson.tag}}</span>
        {{propJson.message}}</p>
      <p class="message"
         v-else>{{propJson.messLeft}}<span class="red">{{propJson.messCenter}}</span>{{propJson.messRight}}</p>
      <div class="btn_box">
        <span class="waitLook"
              :class="{'toLook':propJson.isCacleClick}"
              @click="toHide"
              v-if="propJson.cacleBtn">{{propJson.cacleBtn}}</span>
        <span class="toLook"
              v-if="!propJson.isSecond&&propJson.sureBtn"
              @click="sureClick">{{propJson.sureBtn}}</span>
        <span class="toLook"
              v-if="propJson.isSecond&&propJson.sureBtn"
              @click="secondClick">{{propJson.sureBtn}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['propJson'],
  data () {
    return {
    }
  },
  mounted () {

  },
  methods: {
    toHide () {
      this.$parent.propJson.showToast = false;
    },
    sureClick () {
      this.$emit('sureClick')
    },
    secondClick () {
      this.$emit('secondClick')
    }
  }
}
</script>
<style scoped>
.main_empty {
  width: 100%;
  height: 100%;
}
.shadow {
  position: fixed;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.4;
  z-index: 11;
  top: 0;
  left: 0;
}
.toast {
  width: 2.95rem;
  margin: 0 auto;
  position: fixed;
  top: 1.62rem;
  left: 50%;
  transform: translate(-50%, 0%);
  z-index: 111;
  background: #fff;
  text-align: center;
  border-radius: 10px;
  padding-top: 0.2rem;
  font-weight: 400;
  font-family: PingFangSC;
}
.toast .title {
  font-size: 0.17rem;
  color: #333;
  font-weight: 700;
  font-family: PingFangSC;
}
.toast .message {
  font-family: PingFangSC;
  color: #999;
  font-size: 0.15rem;
  padding: 0 0.25rem;
  text-align: left;
  line-height: 0.3rem;
  height: 0.93rem;
  display: table-cell;
  vertical-align: middle;
}
.toast .btn_box {
  border-top: 1px solid #eeeeee;
  display: flex;
  flex: 1;
  justify-content: space-around;
  font-size: 0.16rem;
}
.toast .waitLook,
.toast .toLook {
  display: inline-block;
  flex: 1;
  padding: 0.2rem 0;
}
.toast .waitLook {
  color: #999999;
  border-right: 1px solid #eee;
}
.toast .toLook {
  color: #4f8cfa;
}
.red {
  color: #ff514a;
  font-size: 0.15rem;
}
.tag {
  color: #406cda;
  font-size: 0.12rem;
  background: #e4eefa;
  padding: 0 0.03rem;
  margin-right: 0.04rem;
}
</style>